import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
  PrimaryModal,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import DownloadAppButton from './DownloadAppButton'
import { hero, heroText, headerbg, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100VH"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          center
          justifyBetween
        >
          <Header />
          <CFView column center ph="3%" w="100%" pb="5px">
            <CFView mv="5px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView mv="5px">
              <DownloadAppButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          justifyBetween
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          zIndex={90}
          relative
        >
          <Header />
          <CFView
            row
            center
            ph="3%"
            w="100%"
            maxWidth="900px"
            pv="5px"
            bg="rgba(0,0,0, 0.8)"
          >
            <CFView pt="3px" pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView pt="3px" ml="15px">
              <DownloadAppButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
